import {makeObservable} from 'mobx';

import type {Nullable} from '../../../utils/utility-types';
import type {DateTimeModel} from '../Date/DateTime.model';

import {BaseModel} from '../../../core/domain/Base/Base.model';

const ModelName = 'MetricModel';

export class MetricModel extends BaseModel {
  static poundsInKilogram = 2.20462;
  created: DateTimeModel;
  date: DateTimeModel;
  updated: DateTimeModel;
  /**
   * Weight in kilograms
   */
  weight: Nullable<number>;

  constructor(props: MetricModel.Props) {
    super(props);
    Object.assign(this, props);

    makeObservable(
      this,
      BaseModel.mobxAnnotationFactory<MetricModel, MetricModel.Props>(props),
    );
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }

  static poundsToKilogram(pounds: number) {
    return parseFloat((pounds / MetricModel.poundsInKilogram).toFixed(8));
  }

  getByUnit(unit: MetricModel.WeightUnit) {
    if (!this.weight) {
      return 0;
    }

    if (unit === 'lbs') {
      return parseFloat(
        (this.weight * MetricModel.poundsInKilogram).toFixed(1),
      );
    }

    return parseFloat(this.weight.toFixed(1));
  }
}

export namespace MetricModel {
  export type Props = BaseModel.ModelToProps<MetricModel, 'getByUnit'>;

  export type WeightUnit = 'kg' | 'lbs';
}
